export default __webpack_public_path__ + "static/media/img_perfil.2951e489.png";